﻿////import * as $ from "jquery";
//import "bootstrap";


export class Loader {

    constructor(element: HTMLElement) {
    }

    public static showLoader(parentElement: HTMLElement, delayInMiliseconds: number = null) {
        //1. Preveri, èe loader v parentElement že obstaja
        var loaderElement = $(document.querySelector(".loader-overlay"))[0] as HTMLElement;
        //2. Èe ne obstaja, ustvarimo HTML element in ga dodamo na zaèetek parentElement.
        if (loaderElement == undefined) {
            document.append(this.getLoaderHtml());
            loaderElement = $(document.querySelector(".loader-overlay"))[0] as HTMLElement;
        }
        //3. Prikažemo loader
        //Èe je nastavljen showAfter potem loader prikažemo šele po delayInMiliseconds milisekundah - uporabimo window.setTimeout
        if (delayInMiliseconds != null) {
            var handle = window.setTimeout(function () {
                $(loaderElement).show();
                $(loaderElement).removeData("timeoutHandle");
            }, delayInMiliseconds);
            $(loaderElement).data("timeoutHandle", handle);
        }
        else {
            $(loaderElement).show();
        }
    }

    public static hideLoader(parentElement: HTMLElement) {
        //1. Preveri, èe loader v parentElementu že obstaja
        var loaderElement = $(document.querySelector(".loader-overlay"))[0] as HTMLElement;
        //2. Èe obstaja ga skrijemo
        if (loaderElement != undefined) {
            window.clearTimeout($(loaderElement).data("timeoutHandle"));
            $(loaderElement).removeData("timeoutHandle");
            $(loaderElement).hide();
        }
    }

    public static getLoaderHtml() {
        return "<div class=\"loader-overlay\" style=\"display:none\">"
            + "<div class=\"loader-wrap\">"
            + "<div class=\"loader-content\"> <span class=\"spinner\"></span></div></div></div>";

    }
}



